import { delay, takeLatest, put, select } from "redux-saga/effects";

export const getState = (state) => state.launcher;

export function* watchLauncherClick() {
  yield takeLatest("LAUNCHER_CLICKED", watchLauncherClickAsync);
}

export function* initLauncher() {
  yield put({ type: "SHOW_LAUNCHER" });
}

export function* showLauncher() {
  let state = yield select(getState);
  
  if (state.isDivWidget) {
    window.parent.postMessage(["setHeightWidget", 595, 800], "*");
    return;
  }

  if (state.showLauncher) {
    window.parent.postMessage(["setHeight", (!state.showWidget) ? 92 : 670, (!state.showWidget) ? 62 : 350], "*");
  } else {
    window.parent.postMessage(["setHeight", 0, 0], "*");
  }
}

function* watchLauncherClickAsync() {
  let state = yield select(getState);
  let showWidget = !state.showWidget;

  if (!showWidget) {
    yield put({ type: "LAUNCHER_CLICKED_ASYNC" });
  }

  yield delay(100);
  window.parent.postMessage(["setHeight", (!showWidget) ? 92 : 670, (!showWidget) ? 62 : 350], "*");
  yield delay(100);
  
  if (showWidget) {
    yield put({ type: "LAUNCHER_CLICKED_ASYNC" });
    yield put({ type: 'LOAD_MESSAGES' });
  }
}